import { createTheme } from '@mui/material/styles';


const darkTheme = createTheme({

    breakpoints: {
        values: {
            xs: 0,
            sm: 480,    // Custom value for mobile
            md: 768,    // Custom value for tablet
            lg: 1024,   // Custom value for desktop
            xl: 1440,   // Custom value for large screens
        },
    },

    // 1. Set the mode to 'dark'
    palette: {
        mode: 'dark',
        primary: {
            main: '#7f0000', // A dark red for primary elements
            light: '#af0000',
            dark: '#4f0000',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#dddddd', // A light gray for secondary elements
            light: '#ffffff',
            dark: '#bbbbbb',
            contrastText: '#000000',
        },
        background: {
            default: '#1d1d1d', // Sets the main background to a very dark gray
            secondary: '#2d2d2d', // Sets the secondary background to a slightly lighter dark gray
            paper: '#3d2d2d',   // Slightly lighter reddish-gray for component surfaces
            paperLight: '#7d6d6d', // Even lighter reddish-gray for highlighting on component surfaces
        },
        paper: {
            default: '#3d2d2d',
            default2: '#4d3d3d',
            light: '#7d6d6d',
            verylight: '#fddddd',
            dark: '#2d1d1d',
        },
        text: {
            primary: '#ffffff', // White text for good contrast
            secondary: '#b3b3b3', // Very dark gray secondary
        },
        divider: '#424242',
        status: {
            good: 'lightgreen',
            bad: 'red',
            middle: '#f6a973',
        }
    },

    // 2. Customize typography
    typography: {
        fontFamily: 'Roboto, sans-serif',
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.5,
        },
    },

    // 3. Add global spacing
    spacing: 8,

    // 4. Customize specific component styles
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#7f0000', // Ensure app bar matches the paper background
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: ({theme}) => ({
                    borderRadius: 16,
                    color: '#ffffff',
                    height: '64px',
                    // Use a media query to override for mobile screens
                    [theme.breakpoints.down('sm')]: {
                        height: '96px',
                    },
                }),
                containedPrimary: {
                    backgroundColor: '#7f0000',
                    color: '#ffffff',
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: '#4f0000', // Darker shade on hover
                        },
                    },
                },
                outlinedPrimary: ({theme}) => ({
                    backgroundColor: 'transparent',
                    color: 'white',
                    outline: 1,
                    outlineColor: theme.palette.paper.light,
                    borderColor: theme.palette.paper.light,
                    
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: theme.palette.paper.default, // Light up with the same color
                        },
                    },
                })
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: ({theme}) => ({
                    padding: '16px',
                    backgroundColor: theme.palette.paper.default2,
                    backgroundImage: 'none',
                }),
            },
            variants: [
                {
                    props: { variant: 'main' },
                    style: ({theme}) => ({
                        maxWidth: '900px',
                        padding: '32px',
                        backgroundColor: theme.palette.paper.default2,
                        width: '90vw',
                        minHeight: '100px',
                        alignContent: 'center',
                        elevation: 1,
                    })
                }
            ]
        },

        MuiTypography: {
            variants: [
                {
                    props: { variant: 'italic' },
                    style: ({theme}) => ({
                        fontStyle: 'italic',
                        color: theme.palette.text.secondary
                    }),
                }
            ]
        },
        
        MuiTextField: {
            styleOverrides: {
                root: ({ theme }) => ({
                    // Target the input element for date and time types
                    '& .MuiInputBase-input[type="date"], & .MuiInputBase-input[type="time"]': {
                        minHeight: '32px',
                        [theme.breakpoints.down('sm')]: {
                            height: '32px',
                        },
                    },
                }),
            },
        },
    },
});

export default darkTheme;